import styled from 'styled-components'

export const ScrollContainer = styled.div<{ $opacity: number }>`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  opacity: ${({ $opacity }) => $opacity};
  transition: opacity 0.15s ease;
`

export const PageListWrapper = styled.div<{
  $gap: number
  $padding: number
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ $gap }) => $gap}px;
  padding: ${({ $padding }) => $padding}px;
  min-width: fit-content;
`

export const PageSlot = styled.div<{
  $width: number
  $height: number
}>`
  position: relative;
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
  flex-shrink: 0;
  background-color: white;
  box-shadow:
    0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.12),
    0 0.0625rem 0.125rem rgba(0, 0, 0, 0.24);
`

export const PageSpacer = styled.div<{
  $width: number
  $height: number
}>`
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
  flex-shrink: 0;
`

export const PageImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  user-select: none;
  pointer-events: none;
`

export const PageOverlayContainer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: auto;
`
